export default __webpack_public_path__ + "static/title-news-zh-Hant-b1ebebd337f9eda5f23a8da997d47a41.png";